import { type Registry as Services, service } from '@ember/service';
import { t } from 'ember-intl';
import GeneralChartsOtaChart from 'lumen/components/general/charts/ota-chart';
import GeneralTooltipsTooltipOtb from 'lumen/components/general/tooltips/tooltip-otb';
import HotelMarketInsightChartsBaseChartOtbBase from 'lumen/components/hotel/market-insight/charts/base/chart-otb-base';
import { TOTAL_OTB } from 'lumen/utils/constants/chart-color-constants';

export default class HotelMarketInsightChartsChartWowChange extends HotelMarketInsightChartsBaseChartOtbBase {
  @service declare access: Services['access'];
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];
  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get chartData() {
    const { occupancyChangeExtractDate } = this;

    const hasMarketOTB = this.access.hasFeature('otb.market_benchmark');
    const otbSeries = {
      type: 'column',
      name: this.intl.t('rates.my_OTB'),
      data: [],
      color: TOTAL_OTB,
      borderWidth: 1,
      borderColor: 'var(--prism-color-elevation-surface)',
    };

    const otbBenchmarkSeries = {
      type: 'area',
      name: this.intl.t('rates.tooltip.market_otb'),
      data: [],
      color: 'var(--prism-color-chart-accent-primary-figure-default)',
      opacity: 1,
      fillOpacity: 0.15,
      borderWidth: 1,
      marker: { enabled: false },
    };

    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    this.args.sortedDays.forEach((day) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
      const occupancy = day.occupancy ?? day.weeklyOccupancy;

      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      const occupancyChange = occupancy.occupancyChangeForExtractDate(
        occupancyChangeExtractDate,
      );

      const x = this.hotelAndMarketService.toLocalUnixTime(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        occupancy.day?.date?.unix(),
      );
      // @ts-expect-error: Incorrect type
      otbSeries.data.push({
        x,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        y: occupancy.occupancyChangeVersusPercentage(occupancyChange),
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        day: occupancy.day,
      });

      if (hasMarketOTB) {
        // @ts-expect-error: Incorrect type
        otbBenchmarkSeries.data.push({
          x,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
          y: occupancy.benchmarkChangeVersusPercentage(occupancyChange),
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          day: occupancy.day,
        });
      }
    });

    return hasMarketOTB ? [otbSeries, otbBenchmarkSeries] : [otbSeries];
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get chartOptions() {
    const chartOptions = super.chartOptions;
    // @ts-expect-error: Incorrect type
    chartOptions.title = {
      text: 'chart-otb-wow-change',
    };
    return chartOptions;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get occupancyChangeExtractDate() {
    // Subtract the number of refDaysAgo to get the correct extract date
    return (
      this.hotelAndMarketService
        .getLocalTime()
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        .subtract(this.args.refDaysAgo, 'day')
        .format('YYYY-MM-DD')
    );
  }

  <template>
    <GeneralChartsOtaChart
      {{! @glint-expect-error: Incorrect type }}
      @chartOptions={{this.chartOptions}}
      @model={{this.chartData}}
      {{! @glint-expect-error: Incorrect type }}
      @onUpdateChartReference={{@onUpdateChartReference}}
    />

    <div class="hidden" id="dummy-tooltip-for-market-otb">
      <div class="tooltip-otb-container">
        {{! @glint-expect-error: Incorrect type }}
        <GeneralTooltipsTooltipOtb
          {{! @glint-expect-error: Incorrect type }}
          @changeRowLabel={{t "general.daysago" count=@refDaysAgo}}
          {{! @glint-expect-error: Incorrect type }}
          @occupancy={{this.tooltipOccupancy}}
          {{! @glint-expect-error: Incorrect type }}
          @referenceOccupancy={{this.tooltipOccupancyChange}}
          @showAvailableRooms={{true}}
          @showChangesRow={{true}}
        />
      </div>
    </div>
  </template>
}
